import React from 'react';
import { ICdwObjectPathComponentFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { CdwObjectRowItem, NonClickablePathItem } from './SelectCdwTableFormUI';
import { ClickablePathItemPair } from './ClickablePathItemPair';

interface IProps {
  path: ICdwObjectPathComponentFieldsFragment[];
  openParent: (index?: number) => void;
}

const CdwTableContainerPath = ({ path, openParent }: IProps) => {
  const pathStrings = ['/', ...path.map((p) => p.name)];

  return (
    <CdwObjectRowItem>
      {pathStrings.map((pathComponentName, ix) =>
        ix === pathStrings.length - 1 ? (
          <NonClickablePathItem key={`${pathComponentName}-${ix}`}>
            {pathComponentName}
          </NonClickablePathItem>
        ) : (
          <ClickablePathItemPair
            key={`${pathComponentName}-${ix}`}
            ix={ix}
            pathComponentName={pathComponentName}
            openParent={openParent}
          />
        ),
      )}
    </CdwObjectRowItem>
  );
};

export default CdwTableContainerPath;
